export const GET_COUNTRIES = "GET_COUNTRIES";
export const GET_COUNTRIES_START = "GET_COUNTRIES_START";
export const GET_COUNTRIES_FAILED = "GET_COUNTRIES_FAILED";
